/* === Arquivo: src/App.js === */

import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Pillars from './components/Pillars/Pillars';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Pillars />
      <Footer />
    </div>
  );
}

export default App;